<template>
  <div
    class="h-[100%] overflow-auto justify-start max-h-[100%] dark:bg-dark-box-background rounded-xl rounded-t-none border-l-0 border-r-0 bg-transparent dark:border-dark-screen-background"
    @scroll="handlePlansScroll">
    <div class="flex flex-col flex-1 justify-start w-full mb-[64px] rounded-md">
      <table
        :class="[plans?.results?.length ? 'h-full' : '']"
        class="w-full divide-y divide-light-divider-border dark:divide-dark-divider-border">
        <thead
          id="table-header"
          class="sticky top-0 z-10 w-full transition ease-in-out bg-light-box-background dark:bg-dark-box-background duration-side-menu-transition-duration">
          <draggable
            v-model="plan_headers"
            :component-data="{
              type: 'transition-group',
              name: !drag ? 'flip-list' : null
            }"
            v-bind="{
              animation: 200,
              group: 'leads header',
              ghostClass: 'ghost',
              chosenClass: 'chosen'
            }"
            handle=".drag-handle"
            filter=".ignore-drag"
            item-key="id"
            class="text-left transition ease-in-out border-light-divider-border dark:border-dark-divider-border text-common-grey duration-side-menu-transition-duration"
            tag="tr"
            @start="drag = true"
            @end="updatePlansHeaders()">
            <template #item="{ element, index }">
              <th v-if="element.id == 'actions'" class="relative w-5 px-6 rounded-md ignore-drag non-draggable">
                <div />
              </th>
              <th
                v-else
                :class="{
                  '!rounded-tr-md': index == plan_headers.length - 1,
                  '!bg-gray-300': element?.is_highlighted
                }"
                class="mr-20 font-semibold text-gray-500 bg-white whitespace-nowrap group/row"
                @click.stop="() => {}">
                <div class="flex justify-between w-full space-x-4">
                  <div
                    class="relative flex items-center w-full py-4"
                    @click.stop=""
                    @mouseout="$event.target.classList.remove('cursor-pointer', 'underline', 'text-blue')"
                    @mouseover="
                      ($event) => {
                        $event?.ctrlKey || $event?.altKey
                          ? $event.target.classList.add('cursor-pointer', 'underline', 'text-blue')
                          : $event.target.classList.remove('cursor-pointer', 'underline', 'text-blue')
                      }
                    ">
                    <button
                      class="absolute h-12 drag-handle w-[105%] text-gray-800 dark:hover:text-white cursor-move active:text-gray-500" />
                    <span class="relative ml-4 mr-4"> {{ $t(element.name) }}</span>
                  </div>

                  <Menu v-slot="{ close }" ref="goalsMenu" as="div" class="relative flex-shrink-0 ml-auto mr-4">
                    <MenuButton
                      :class="{
                        'bg-light-brand-blue': plan_headers.find((x) => x.id == element.id && x?.value)
                      }"
                      class="inline-flex col-table-header-btn items-center justify-center w-10 -mt-[5%] h-[105%] bg-[#F8FAFB] border focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue"
                      @click="click_position = $utils.clone($store.state.ui.cursor_positions?.closest_side)">
                      <ListFilter v-if="plan_headers.find((x) => x.id == element.id && x?.value)" color="white" />
                      <ChevronDown v-else class="w-12 h-12 py-4 text-common-grey" />
                    </MenuButton>
                    <transition
                      enter-active-class="transition duration-100 ease-out"
                      enter-from-class="transform scale-95 opacity-0"
                      enter-to-class="transform scale-100 opacity-100"
                      leave-active-class="transition duration-75 ease-in"
                      leave-from-class="transform scale-100 opacity-100"
                      leave-to-class="transform scale-95 opacity-0">
                      <MenuItems
                        class="absolute font-normal !z-50 w-60 mx-3 mt-0 -ml-28 origin-bottom-right bg-white shadow-lg rounded-lg focus:outline-none">
                        <div class="p-3 hover:bg-gray-100">
                          <Menu v-slot="{ close: closeFilterModal }" ref="goalsMenu" as="div" class="relative flex-shrink-0 ml-auto">
                            <MenuButton
                              class="inline-flex items-center justify-center focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue">
                              <ChevronDown
                                :class="[{ 'rotate-90': click_position == 'right' }, { '-rotate-90': click_position == 'left' }]"
                                class="w-4 h-4 ml-1 mr-5 text-common-grey" />
                              {{ $t("Filter column") }}
                            </MenuButton>
                            <MenuItems
                              :class="[{ '-ml-[307px]': click_position == 'right' }, { 'ml-[232px]': click_position == 'left' }]"
                              class="absolute z-50 mx-3 -mt-12 font-normal origin-bottom-right bg-white rounded-lg shadow-lg w-80 focus:outline-none">
                              <div class="mt-4 mb-4">
                                <span class="m-3">{{ $t("Filter") }} {{ element.name }}</span>
                                <ChevronDown
                                  :class="[{ '-rotate-90': click_position == 'right' }, { 'rotate-90': click_position == 'left' }]"
                                  class="w-5 h-5 ml-auto mr-4 -mt-5 cursor-pointer text-common-grey"
                                  @click="closeFilterModal()" />
                              </div>
                              <ActivitiesColumnsFilter
                                :metric="element"
                                @change="
                                  ($event) => {
                                    if ($event?.value) {
                                      handleChangeColumnFilter($event)
                                      current_column_filter_valid = true
                                    } else {
                                      current_column_filter = null
                                      current_column_filter_valid = false
                                    }
                                  }
                                " />
                              <div class="flex items-center justify-center w-full mt-4 space-x-6">
                                <button
                                  class="-mt-3 text-sm text-light-brand-blue"
                                  @click="handleRemoveColumnFilter(element, closeFilterModal, close)">
                                  {{ $t("Clear filter") }}
                                </button>
                                <!-- 
                                                 <button
                                          class="-mt-3 text-sm text-light-brand-blue"
                                          @click="handleRemoveColumnFilter(element, closeFilterModal, close)">
                                          Clear filter
                                        </button> -->

                                <button
                                  :disabled="!current_column_filter_valid"
                                  class="mb-4 font-normal p-3 rounded-md text-white cursor-pointer bg-light-brand-blue w-44"
                                  @click="handleSubmitColumnFilter(closeFilterModal, close)">
                                  {{ $t("Show results") }}
                                </button>
                              </div>
                            </MenuItems>
                          </Menu>
                        </div>
                        <div
                          v-if="
                            element.id != 'tags' && element.id != 'companies' && element.id != 'contacts' && element.id != 'collaborators'
                          "
                          class="p-3 flex space-x-2 items center hover:bg-[#F8FAFB] cursor-pointer"
                          @click.stop="
                            () => {
                              element.sort_index =
                                element?.sort == 0 || element?.sort == undefined
                                  ? plan_headers.filter((x) => x.sort != 0).length
                                  : element.sort_index
                              element.sort = element.sort == 1 ? 0 : ~-element.sort ^ element.sort
                              sortRecords()
                            }
                          ">
                          <ChevronDown v-if="element.sort == -1" class="w-5 h-5 mr-3 text-common-grey" aria-hidden="true" />
                          <ChevronUp v-else-if="element.sort == 1" class="w-5 h-5 mr-3 text-common-grey" aria-hidden="true" />
                          <ChevronsUpDown v-else class="w-5 h-5 mr-3 text-common-grey" aria-hidden="true" />

                          <span class="">{{ $t("Sort column") }}</span>
                        </div>
                      </MenuItems>
                    </transition>
                  </Menu>
                </div>
              </th>
            </template>
          </draggable>
        </thead>

        <tbody
          v-if="plans?.results?.length"
          class="bg-white dark:bg-dark-box-background divide-light-divider-border dark:divide-dark-divider-border divide-y-[2px]">
          <tr
            v-for="plan in plans?.results"
            :key="plan.id"
            class="h-16 hover:bg-gray-100 dark:hover:bg-gray-600 hover:cursor-pointer"
            @click.stop="$emitter.emit('updatePlan', { plan: $utils.clone(plan) })">
            <template v-for="header in plan_headers" :key="header.id + plan.id">
              <td v-if="header.id == 'actions'" class="px-2 py-0 w-[28px] whitespace-nowrap text-sm text-gray-500">
                <div class="relative flex items-center">
                  <div @click.stop="">
                    <Menu v-if="!editing_disabled" as="div" class="flex-shrink-0 ml-auto">
                      <MenuButton
                        class="inline-flex items-center justify-center text-gray-400 transition ease-in-out rounded duration-side-menu-transition-duration"
                        @click.stop="">
                        <span class="sr-only">{{ $t("Open options") }}</span>
                        <EllipsisVertical :color="$store.state.ui.darkMode ? '#fff' : ''" class="w-5 h-5 border-none" />
                      </MenuButton>
                      <transition
                        enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0"
                        enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-in"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
                        <MenuItems
                          class="absolute left-0 z-30 flex flex-col items-start content-center justify-center p-2 mx-3 mt-1 origin-top-right bg-white rounded-md shadow-lg outline-none dark:bg-dark-screen-background ring-1 ring-black ring-opacity-5 focus:outline-none">
                          <MenuItem
                            v-if="plan?.companies[0]"
                            v-slot="{ active }"
                            @click.prevent="
                              () => {
                                $utils.Record(plan.companies[0]).open()
                              }
                            ">
                            <div
                              :class="[
                                active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                                'group flex items-center px-3 py-2 text-sm'
                              ]">
                              <Link color="#899399" class="w-5 h-5 mr-2 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
                              <span>{{ $t("Visit") }} {{ plan.companies[0].name }}</span>
                            </div>
                          </MenuItem>
                          <MenuItem
                            v-slot="{ active }"
                            @click.prevent="
                              () => {
                                $emitter.emit('updatePlan', {
                                  plan: $utils.clone(plan)
                                })
                              }
                            ">
                            <div
                              :class="[
                                active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                                'group flex items-center px-3 py-2 text-sm'
                              ]">
                              <Pencil color="#899399" class="w-5 h-5 mr-2 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
                              <span>{{ $t("Update Plan") }}</span>
                            </div>
                          </MenuItem>
                          <MenuItem
                            v-slot="{ active }"
                            @click.prevent="
                              () => {
                                $emitter.emit('updatePlan', {
                                  plan: $utils.clone(plan),
                                  is_template: true
                                })
                              }
                            ">
                            <div
                              :class="[
                                active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                                'group flex items-center px-3 py-2 text-sm'
                              ]">
                              <LayoutPanelTop
                                color="#899399"
                                class="w-5 h-5 mr-2 text-gray-400 group-hover:text-gray-500"
                                aria-hidden="true" />
                              <span>{{ $t("Use as Template") }}</span>
                            </div>
                          </MenuItem>
                          <MenuItem
                            v-slot="{ active }"
                            @click.prevent="
                              () => {
                                $emitter.emit(ALL_EMITTERS.DELETE_OBJECT, {
                                  object: { ...plan, type: 'Plan' },
                                  objectDeleteCallBack: () => {
                                    $emit('cancel')
                                  }
                                })
                              }
                            ">
                            <div
                              :class="[
                                active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                                'group flex items-center px-3 py-2 text-sm'
                              ]">
                              <Trash2 class="w-5 h-5 mr-2 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
                              <span>{{ $t("Delete Plan") }}</span>
                            </div>
                          </MenuItem>
                        </MenuItems>
                      </transition>
                    </Menu>
                  </div>
                </div>
              </td>
              <td v-if="header.id == 'status'" class="px-6 py-0 w-[170px] whitespace-nowrap text-sm text-gray-500">
                <div class="flex items-center">
                  <ToggleStatusButton :object="plan" />
                  <div
                    v-if="plan?.summay?.dynamic_status == 'completed' || plan.status == 'completed'"
                    class="flex items-center justify-center ml-1 w-10 h-10 rounded-full bg-gradient-to-b from-[#841FF4] to-[#4581DF]"
                    @click.stop="$emitter.emit(ALL_EMITTERS.SHARE_ACTIVITY, plan)">
                    <Share2 class="w-5 h-5 text-white" aria-hidden="true" />
                  </div>
                </div>
              </td>
              <td
                v-if="!tied_record && header.id == 'name'"
                class="items-center min-w-[150px] px-2 dark:text-dark-body-text whitespace-nowrap text-sm font-medium text-gray-900">
                <div class="flex gap-x-1 max-w-[700px]">
                  <div
                    class="px-2 max-w-[640px] relative flex-wrap text-sm font-bold capitalize has-tooltip text-light-body dark:text-dark-body-text whitespace-nowrap">
                    <p class="max-w-[640px] truncate text-ellipsis">
                      {{ plan?.name }}
                    </p>
                    <span
                      class="inline-flex items-center gap-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                      {{ plan?.name }}
                    </span>
                  </div>

                  <div class="relative flex gap-1 ml-1">
                    <Badge :icon="task_icon" :object="plan" :list-name="'tasks'" />
                    <Badge :icon="goalstar_icon" :object="plan" :list-name="'goals'" />
                  </div>
                </div>
              </td>
              <td
                v-else-if="tied_record && header.id == 'name'"
                class="items-center min-w-[150px] px-2 dark:text-dark-body-text whitespace-nowrap text-sm font-medium text-gray-900">
                <div class="flex gap-x-1 max-w-[700px]">
                  <div
                    class="px-2 max-w-[640px] relative flex-wrap text-sm font-bold capitalize has-tooltip text-light-body dark:text-dark-body-text whitespace-nowrap">
                    <p class="max-w-[640px] truncate text-ellipsis">
                      {{ plan?.name }}
                    </p>
                    <span
                      class="inline-flex items-center gap-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                      {{ plan?.name }}
                    </span>
                  </div>

                  <div class="relative flex gap-1 ml-1">
                    <Badge :icon="task_icon" :object="plan" :list-name="'tasks'" />
                    <Badge :icon="goalstar_icon" :object="plan" :list-name="'goals'" />
                  </div>
                </div>
              </td>
              <td
                v-else-if="header.id == 'tags'"
                class="items-center min-w-[150px] px-2 dark:text-dark-body-text whitespace-nowrap text-sm font-medium text-gray-900">
                <div v-if="plan?.tags?.length" class="flex flex-row gap-1 flex-nowrap">
                  <div
                    v-for="tag in plan?.is_all_assigned_tags_shown ? plan?.tags : plan?.tags?.slice(0, 2)"
                    :key="tag"
                    class="flex justify-between px-2 py-2 pl-3 text-left rounded-lg dark:text-dark-body-text focus:outline-none"
                    :style="{
                      background: `${all_tags.find((t) => t.id == tag)?.color}0F`
                    }">
                    <span class="flex items-center mr-1">
                      <span
                        class="mr-2 w-3.5 h-3.5 rounded-full"
                        :style="{
                          background: all_tags.find((t) => t.id == tag)?.color
                        }" />
                      <span
                        class="block font-bold truncate"
                        :style="{
                          color: all_tags.find((t) => t.id == tag)?.color
                        }">{{ all_tags.find((t) => t.id == tag)?.name }}</span>
                    </span>
                  </div>
                  <div
                    v-if="plan?.tags?.length > 2 && !plan?.is_all_assigned_tags_shown"
                    class="flex items-center flex-none mr-1 font-normal group/tags flex-nowrap dark:text-white">
                    <span class="block group-hover/tags:hidden">+{{ plan?.tags?.length - 2 }} {{ $t("more") }}</span>
                    <div class="relative" @click.stop="showAllAssignedTags(plan)">
                      <transition
                        class="hidden group-hover/tags:block"
                        mode="out-in"
                        enter-active-class="animate__animated animate__fadeIn"
                        leave-active-class="animate__animated animate__fadeOut"
                        duration="100">
                        <button
                          class="z-30 flex items-center justify-center w-7 h-7 p-1.5 ml-2 transition-all border rounded-md opacity-0 group-hover/tags:delay-300 group-hover/tags:duration-300 group-hover/tags:opacity-100 group-hover/tags:scale-125 group-hover/tags:bg-gray-200">
                          <ArrowLeftFromLine
                            class="absolute inset-0 w-5 h-5 m-auto text-white"
                            :class="[$store.state.portfolio.ui_options?.language == 'ar' ? '' : 'rotate-180']" />
                        </button>
                      </transition>
                    </div>
                  </div>
                  <div
                    v-else-if="plan?.tags?.length > 2 && plan?.is_all_assigned_tags_shown"
                    class="flex items-center flex-none mr-1 font-normal flex-nowrap dark:text-white"
                    @click.stop="showAllAssignedTags(plan)">
                    <div class="relative">
                      <transition
                        mode="out-in"
                        enter-active-class="animate__animated animate__fadeIn"
                        leave-active-class="animate__animated animate__fadeOut"
                        duration="100">
                        <button
                          class="z-30 hover:scale-125 flex items-center justify-center w-7 h-7 p-1.5 transition-all duration-300 delay-300 hover:bg-gray-200 border rounded-md">
                          <ArrowLeftFromLine
                            class="absolute inset-0 w-5 h-5 m-auto"
                            :class="[$store.state.portfolio.ui_options?.language == 'ar' ? 'rotate-180' : '']" />
                        </button>
                      </transition>
                    </div>
                  </div>
                </div>
                <div v-else class="flex flex-row items-center flex-none gap-1 pl-2 flex-nowrap">
                  -
                </div>
              </td>
              <td v-if="header.id == 'companies'" class="px-6 text-sm text-gray-500 whitespace-nowrap group/notes">
                <div v-if="plan.companies?.length == 1">
                  <div class="flex items-center justify-start" @click.stop="">
                    <Menu v-if="!editing_disabled" as="div" class="flex-shrink-0">
                      <MenuButton
                        class="inline-flex items-start justify-start flex-shrink-0 rounded-full border-1 focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue">
                        <img
                          onerror="this.style.display='none'"
                          class="inline-block object-contain rounded-full h-9 w-9"
                          :src="`https://logosnap.io/api/${$utils.getDomainName(
                            plan.companies[0].values[$utils.getOptionMetricReference('company', 'website')]
                          )}?token=ecoTB81m5dQqkrjw`"
                          alt="">
                        <div class="text-start has-tooltip">
                          <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                            {{
                              Record.from(plan.companies[0]).name?.length > 18
                                ? Record.from(plan.companies[0]).name.slice(0, 17) + "..."
                                : Record.from(plan.companies[0]).name
                            }}
                          </p>
                          <span
                            v-if="Record.from(plan.companies[0]).name?.length > 18"
                            class="px-2 py-1 text-sm font-medium rounded-md flex truncate tooltip [600px] max-w-[600px] bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                            {{ Record.from(plan.companies[0]).name }}
                          </span>
                          <p class="text-xs font-medium dark:!text-gray-300 text-gray-600 group-hover:text-gray-900 capitalize">
                            {{ plan.companies[0].type }}
                          </p>
                        </div>
                      </MenuButton>
                      <transition
                        enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0"
                        enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-in"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
                        <MenuItems
                          :style="{
                            marginTop: `${plans_top_scroll * -1}px`
                          }"
                          as="ul"
                          class="absolute z-50 mx-3 -ml-10 origin-bottom-right bg-white border rounded-md shadow-sm focus:outline-none">
                          <MenuItem v-for="item in getRecordActions(plan.companies[0])" :key="item.name" v-slot="{ active }" as="li">
                            <div v-if="item?.divider" class="divide-y divide-gray-100" />
                            <button
                              v-else
                              :disabled="item.disabled"
                              :class="[
                                active
                                  ? 'bg-light-brand-blue dark:bg-dark-brand-blue text-dark-body-text'
                                  : 'text-light-body-text dark:text-dark-body-text',
                                'w-full group sm:text-sm flex items-center px-4 py-2  disabled:dark:bg-dark-transparent-brand-blue disabled:cursor-default disabled:opacity-60 transition ease-in-out duration-side-menu-transition-duration'
                              ]"
                              @click="item.action">
                              <component
                                :is="item.icon"
                                v-if="item.icon"
                                :class="active ? 'text-dark-body-text' : 'text-common-grey'"
                                class="w-5 h-5 mr-3 transition ease-in-out duration-side-menu-transition-duration"
                                aria-hidden="true" />
                              <p>
                                {{ item.name?.length > 18 ? item.name.slice(0, 17) + "..." : item.name }}
                              </p>
                            </button>
                          </MenuItem>
                        </MenuItems>
                      </transition>
                    </Menu>
                    <div class="relative ml-4 -mt-4" @click.stop="openModalNotes(plan.companies[0])">
                      <NotesIcon
                        :class="[
                          plan.companies[0]?.notes_summary?.count == 0 || plan.companies[0]?.notes?.length == 0
                            ? 'opacity-0'
                            : 'opacity-100',
                          'group-hover/notes:opacity-100 mr-2 w-5 h-5'
                        ]" />
                      <div class="flex justify-center items-center absolute left-0.5 top-0">
                        <div class="flex items-center justify-center w-4 h-4 text-xs font-bold text-center text-white rounded-full">
                          <Plus
                            v-if="plan.companies[0]?.notes_summary?.count == 0 || plan.companies[0]?.notes?.length == 0"
                            class="w-5 h-5 text-white transition opacity-0 group-hover/notes:opacity-100" />
                          <div v-else>
                            {{ plan.companies[0]?.notes_summary?.count || plan.companies[0]?.notes.length }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="plan.companies?.length > 1" @click.stop>
                  <div class="flex space-x-[1px] overflow-hidde items-center">
                    <span v-for="company in plan.companies.slice(0, 4)" :key="company.id" class="inline-block has-quick-tooltip">
                      <Menu v-if="!editing_disabled" as="div" class="flex-shrink-0">
                        <MenuButton
                          class="inline-flex items-start justify-start flex-shrink-0 rounded-full border-1 focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue">
                          <img
                            v-if="company.values[$utils.getOptionMetricReference('company', 'website')]"
                            onerror="this.style.display='none'"
                            :src="`https://logosnap.io/api/${$utils.getDomainName(
                              company.values[$utils.getOptionMetricReference('company', 'website')]
                            )}?token=ecoTB81m5dQqkrjw`"
                            class="inline-block object-contain rounded-full h-9 w-9"
                            alt=""
                            @click.stop="">
                          <Avatar v-else :first-name="Record.from(company).name" last-name="" />
                          <span
                            :style="{
                              marginTop: `${plans_top_scroll * -1}px`
                            }"
                            class="p-1 bg-gray-300 rounded-sm quick-tooltip whitespace-nowrap">
                            <div class="">
                              <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                                {{ Record.from(company).name }}
                              </p>
                            </div>
                          </span>
                        </MenuButton>
                        <transition
                          enter-active-class="transition duration-100 ease-out"
                          enter-from-class="transform scale-95 opacity-0"
                          enter-to-class="transform scale-100 opacity-100"
                          leave-active-class="transition duration-75 ease-in"
                          leave-from-class="transform scale-100 opacity-100"
                          leave-to-class="transform scale-95 opacity-0">
                          <MenuItems
                            :style="{
                              marginTop: `${plans_top_scroll * -1}px`
                            }"
                            as="ul"
                            class="absolute z-50 mx-3 mt-3 -ml-10 origin-bottom-right bg-white border rounded-md shadow-sm focus:outline-none">
                            <MenuItem v-for="item in getRecordActions(company)" :key="item.name" v-slot="{ active }" as="li">
                              <div v-if="item?.divider" class="divide-y divide-gray-100" />
                              <button
                                v-else
                                :disabled="item.disabled"
                                :class="[
                                  active
                                    ? 'bg-light-brand-blue dark:bg-dark-brand-blue text-dark-body-text'
                                    : 'text-light-body-text dark:text-dark-body-text',
                                  'w-full group sm:text-sm flex items-center px-4 py-2  disabled:dark:bg-dark-transparent-brand-blue disabled:cursor-default disabled:opacity-60 transition ease-in-out duration-side-menu-transition-duration'
                                ]"
                                @click="item.action">
                                <component
                                  :is="item.icon"
                                  v-if="item.icon"
                                  :class="active ? 'text-dark-body-text' : 'text-common-grey'"
                                  class="w-5 h-5 mr-3 transition ease-in-out duration-side-menu-transition-duration"
                                  aria-hidden="true" />
                                <p>
                                  {{ item.name?.length > 18 ? item.name.slice(0, 17) + "..." : item.name }}
                                </p>
                              </button>
                            </MenuItem>
                          </MenuItems>
                        </transition>
                      </Menu>
                    </span>
                    <span
                      v-if="plan.companies?.length > 4"
                      class="relative ml-auto text-sm left-6 text-light-brand-blue dark:text-dark-brand-blue">
                      + {{ plan.companies?.length - 4 }} {{ $t("more") }}</span>
                  </div>
                </div>
                <div v-else>
                  <span
                    class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium capitalize rounded-xl bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                    {{ $t("Not Assigned") }}
                  </span>
                </div>
              </td>
              <td v-if="header.id == 'contacts'" class="px-6 text-sm text-gray-500 whitespace-nowrap">
                <div v-if="plan.contacts?.length == 1">
                  <div class="flex items-center h-16">
                    <div class="flex-shrink-0">
                      <img
                        v-if="plan.contacts[0].avatar"
                        class="inline-block rounded-full h-9 w-9 object-cover"
                        :src="plan.contacts[0].avatar"
                        alt="">
                      <Avatar
                        v-else
                        :first-name="Record.from(plan.contacts[0]).first_name"
                        :last-name="Record.from(plan.contacts[0]).last_name" />
                    </div>
                    <div class="ml-3">
                      <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                        {{ Record.from(plan.contacts[0]).full_name }}
                      </p>
                    </div>
                  </div>
                </div>
                <div v-else-if="plan.contacts?.length > 1">
                  <div class="flex items-center -space-x-4 overflow-hidden">
                    <span v-for="user in plan.contacts.slice(0, 4)" :key="user.id" class="flex-shrink-0 inline-block has-tooltip">
                      <img v-if="user.avatar" class="inline-block rounded-full h-9 w-9 object-cover" :src="user.avatar" alt="">
                      <Avatar v-else :first-name="Record.from(user).first_name" :last-name="Record.from(user).last_name" />
                      <span class="p-1 bg-gray-300 rounded-sm tooltip whitespace-nowrap">
                        <div class="">
                          <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                            {{ Record.from(user).full_name }}
                          </p>
                        </div>
                      </span>
                    </span>
                    <span
                      v-if="plan.contacts?.length > 4"
                      class="relative ml-auto text-sm left-6 text-light-brand-blue dark:text-dark-brand-blue">
                      + {{ plan.contacts?.length - 4 }} {{ $t("more") }}</span>
                  </div>
                </div>
                <div v-else class="mt-6">
                  <span
                    class="inline-flex items-center flex-shrink-0 gap-2 px-2 mt-2 text-sm font-medium capitalize max-h-0 rounded-xl dark:text-dark-body-text"
                    @click.stop>
                    <div class="flex w-full -mt-6 -ml-3">
                      <ContactsSelect
                        :disabled="editing_disabled"
                        :companies="plan.companies"
                        label=""
                        @update:selected-contacts="
                          ($event) => {
                            handlePlanSetContactsList($event, plan)
                          }
                        " />
                    </div>
                  </span>
                </div>
              </td>
              <td
                v-if="header.id == 'collaborators'"
                class="flex items-center h-full px-6 text-sm text-gray-500 whitespace-nowrap dark:text-dark-body-text">
                <div class="flex items-center">
                  <div v-if="plan.collaborators?.length == 1">
                    <div class="flex items-center">
                      <div class="flex-shrink-0 h-9 w-9">
                        <img
                          v-if="plan.collaborators[0].avatar"
                          class="inline-block rounded-full h-9 w-9 object-cover"
                          :src="$utils.extractUrl(plan.collaborators[0].avatar)"
                          alt="">
                        <Avatar v-else :first-name="plan.collaborators[0].first_name" :last-name="plan.collaborators[0].last_name" />
                      </div>
                      <div class="ml-3">
                        <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                          {{ plan.collaborators[0].first_name }}
                          {{ plan.collaborators[0].last_name }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="plan.collaborators?.length > 1">
                    <div class="flex items-center -space-x-4 overflow-hidden">
                      <span v-for="user in plan.collaborators.slice(0, 4)" :key="user.id" class="flex-shrink-0 inline-block has-tooltip">
                        <img
                          v-if="user.avatar"
                          class="inline-block rounded-full h-9 w-9 object-cover"
                          :src="$utils.extractUrl(user.avatar)"
                          alt="">
                        <Avatar v-else :first-name="user.first_name" :last-name="user.last_name" />
                        <span class="p-1 bg-gray-300 rounded-sm tooltip whitespace-nowrap">
                          <div class="">
                            <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                              {{ user.first_name }} {{ user.last_name }}
                            </p>
                          </div>
                        </span>
                      </span>
                      <span
                        v-if="plan.collaborators?.length > 4"
                        class="relative ml-auto text-sm left-6 text-light-brand-blue dark:text-dark-brand-blue">
                        + {{ plan.collaborators?.length - 4 }} {{ $t("more") }}</span>
                    </div>
                  </div>
                  <div v-else class="mt-6">
                    <span
                      class="inline-flex items-center gap-2 pl-2 mt-2 text-sm font-medium capitalize rounded-xl dark:text-dark-body-text"
                      @click.stop>
                      <div class="flex w-full -mt-9 -ml-3">
                        <TeamMembersSelect
                          :disabled="editing_disabled"
                          label=""
                          @update:selected-team-members="
                            ($event) => {
                              handlePlanSetTeamMembersList($event, plan)
                            }
                          " />
                      </div>
                    </span>
                  </div>
                  <div
                    class="flex items-center justify-center ml-1 w-8 min-w-8 h-8 min-h-8 rounded-full bg-gradient-to-b from-[#841FF4] to-[#4581DF]"
                    @click.stop="$emitter.emit(ALL_EMITTERS.INVITE_TEAMMATES)">
                    <ShareTeamMembersIcon class="w-5 h-5 text-white" aria-hidden="true" />
                  </div>
                </div>
              </td>
              <td v-if="header.id == 'start_date'" class="px-6 text-sm text-gray-500 whitespace-nowrap">
                <span v-if="plan.start_date" v-tooltip="`${$moment(plan.start_date).format('DD MMM YYYY hh:mm')}`">
                  {{ $moment(plan.start_date).format("DD MMM YYYY") }}
                </span>
                <span v-else> - </span>
              </td>
              <td v-if="header.id == 'date'" class="px-6 text-sm text-gray-500 whitespace-nowrap">
                <span v-if="plan.due_date">
                  {{ $moment.utc(plan.due_date).local().format("DD MMM YYYY") }}
                </span>
                <span v-else> - </span>
              </td>
            </template>
          </tr>
        </tbody>
        <tbody v-else class="h-full">
          <tr>
            <td colspan="12">
              <div class="flex flex-col items-center justify-center h-full">
                <h3 class="mt-2 text-xl font-normal text-black dark:text-white">
                  {{
                    plan_filters?.length || plans_search_term ? $t("No available plans matching applied filters") : $t("No available plans")
                  }}
                </h3>
                <p class="mt-2 font-normal text-gray-500 text-md">
                  {{
                    plan_filters?.length || plans_search_term
                      ? $t("Clear filters to see original list")
                      : editing_disabled
                        ? ""
                        : $t("Click on the button at the bottom to create a new Plan.")
                  }}
                </p>
                <img class="flex-shrink-0 mt-4 pointer-events-none h-[100px] w-[100px]" src="@/assets/tasks-completed.png" alt="">
                <div
                  class="flex mt-6 cursor-pointer items-center border-transparent bg-gradient-to-r from-[#2DA7D7] to-[#841FF4] px-6 font-bold text-white rounded-full w-fit-content mr-[4px] h-[50px] content-center text-[14px]"
                  @click="plan_filters?.length || plans_search_term ? handleClickFilter() : editing_disabled ? null : createNewPlan()">
                  <div class="pl-1" :class="[{ 'has-tooltip': editing_disabled }]">
                    <span v-if="plan_filters?.length || plans_search_term"> {{ $t("Clear filters") }} </span>
                    <span v-else> {{ $t("Create Plan") }} </span>
                    <span v-if="editing_disabled"
                          class="flex-wrap p-2 bg-gray-300 rounded tooltip whitespace-nowrap mt-7">{{ $t("You don't have access to this feature") }}
                    </span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="w-full bg-white dark:bg-dark-box-background">
      <div class="absolute bottom-0 w-full pt-2 overflow-visible bg-white border-t h-14 dark:bg-dark-box-background">
        <PaginationFooter :min-page-size="5" :default-page-size="page_size" :object="plans" @update="updatePlansPage" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  ListFilter,
  ChevronDown,
  ChevronUp,
  ChevronsUpDown,
  Share2,
  Plus,
  Trash2,
  User,
  Users,
  EllipsisVertical,
  Link,
  Mail,
  Pencil,
  Star,
  List,
  ClipboardCheck,
  ArrowLeftFromLine,
  LayoutPanelTop,
  StickyNote
} from "lucide-vue-next"
import ShareTeamMembersIcon from "@/components/shared/icons/ShareTeamMembersIcon.vue"
import Avatar from "@/components/shared/Avatar.vue"
import ContactsSelect from "@/components/shared/ContactsSelect.vue"
import TeamMembersSelect from "@/components/shared/TeamMembersSelect.vue"
import ToggleStatusButton from "@/components/shared/ToggleStatusButton.vue"
import { event as google_event } from "vue-gtag-next"
import { Record } from "@/models/record"
import Badge from "@/components/shared/ActivityStatusBadge.vue"
import ActivitiesColumnsFilter from "@/components/shared/ActivitiesColumnsFilter.vue"
import { markRaw } from "vue"
import { Switch } from "@headlessui/vue"
import dataService from "@/services/data.service"
import NotesIcon from "@/components/shared/icons/NotesIcon.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import draggable from "vuedraggable"
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue"
import PaginationFooter from "@/components/shared/PaginationFooter.vue"

export default {
  components: {
    ShareTeamMembersIcon,
    ArrowLeftFromLine,
    draggable,
    NotesIcon,
    Pencil,
    LayoutPanelTop,
    PaginationFooter,
    Link,
    ActivitiesColumnsFilter,
    ChevronDown,
    ListFilter,
    ChevronUp,
    Share2,
    ChevronsUpDown,
    Trash2,
    User,
    Users,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    Badge: markRaw(Badge),
    List,
    Plus,
    Mail,
    Avatar,
    StickyNote,
    ClipboardCheck: markRaw(ClipboardCheck),
    Star: markRaw(Star),
    ContactsSelect,
    TeamMembersSelect,
    ToggleStatusButton,
    Switch,
    EllipsisVertical
  },
  inject: ["canUserEditLayout", "updateCursorPosition"],
  props: {
    plansSearchTerm: {
      type: String,
      default: ""
    },
    initialFilter: {
      type: Object,
      default: () => ({})
    },
    connectTo: {
      type: String,
      default: ""
    },
    linkedRecord: null,
    componentReference: {
      type: String,
      required: false
    },
    preservedPageSize: {
      type: Number,
      default: 5
    },
    currentTemplate: {
      type: Object,
      required: false
    },
    currentCompany: {
      type: Object,
      required: false
    }
  },
  emits: ["preservedFilters", "cancel"],
  data() {
    return {
      all_headers: [
        {
          label: this.$t("Status"),
          id: "status",
          name: this.$t("Status"),
          sort: 0,
          value: null
        },
        {
          label: this.$t("Name"),
          id: "name",
          name: this.$t("Name"),
          sort: 0,
          value: null
        },
        {
          label: this.$t("Assigned Tags"),
          id: "tags",
          name: this.$t("Assigned Tags"),
          sort: 0,
          value: null
        },
        {
          label: this.$t("Company/Opportunity"),
          id: "companies",
          name: this.$t("Company/Opportunity"),
          sort: 0,
          value: null
        },
        {
          label: this.$t("Contacts"),
          id: "contacts",
          name: this.$t("Contacts"),
          sort: 0,
          value: null
        },
        {
          label: this.$t("Team Members"),
          id: "collaborators",
          name: this.$t("Team Members"),
          sort: 0,
          value: null
        },
        {
          label: this.$t("Start Date"),
          id: "start_date",
          name: this.$t("Start Date"),
          sort: 0,
          value: null
        },
        {
          label: this.$t("Due Date"),
          id: "date",
          name: this.$t("Due Date"),
          sort: 0,
          value: null
        }
      ],
      plan_filters: [],
      current_column_filter_valid: false,
      current_column_filter: null,
      click_position: null,
      all_tags: [],
      drag: false,
      ordering_query: "",
      plan_headers: [],
      ALL_EMITTERS,
      plans_top_scroll: 0,
      Record,
      task_icon: ClipboardCheck,
      goalstar_icon: Star,
      dots_icon: EllipsisVertical,

      //plans
      plans: { results: [], count: 0 },
      plans_status: null,
      plans_search_term: "",
      plans_companies: null,
      plans_contacts: null,
      plans_assigned_to: null,
      plans_due_date_range: null,
      plans_start_date_range: null,

      dont_fetch: false,
      tied_record_full: null,
      page_size: 5
    }
  },
  computed: {
    current_headers() {
      return this.$store.state.ui_options.plans_activities_table_headers
    },
    editing_disabled() {
      let editing_disabled_calc = false

      if (this.$route.name == "WorkspaceItem" && this.$store.state.ui.workspace_user_access_scope == "read") {
        editing_disabled_calc = true
      }

      if (this.$route.name == "Dashboard" && this.$route.params.page) {
        const current_template = this.$store.state.portfolio.shared_layouts.find((l) => l.id == this.$route.params.page)
        if (!this.canUserEditLayout(this.$store.state.auth.user, current_template)) {
          editing_disabled_calc = true
        }
      }

      return editing_disabled_calc
    },
    tied_record() {
      if (this.initialFilter?.companies?.includes("this_record") || this.connectTo == "this_record") {
        return this.$route.params.cid
      } else if (this.connectTo == "another_record") {
        return this.linkedRecord
      } else {
        return null
      }
    }
  },

  watch: {
    plan_filters: {
      deep: true,
      handler() {
        this.getPlans()
      }
    },
    current_headers() {
      this.refreshTableView()
    },
    initialFilter: {
      deep: true,
      handler() {
        this.refetchList()
      }
    },
    tied_record_full() {
      this.getPlans()
    },
    connectTo() {
      this.getTiedCompany()
    },
    linkedRecord: {
      deep: true,
      handler() {
        this.getTiedCompany()
      }
    },
    plansSearchTerm: {
      handler() {
        this.plans_search_term = this.plansSearchTerm
        if (!this.dont_fetch) {
          this.getPlans()
        }
      }
    },
    plans_companies: {
      deep: true,
      handler() {
        if (!this.dont_fetch) {
          this.getPlans()
        }
      }
    },
    plans_contacts: {
      deep: true,
      handler() {
        if (!this.dont_fetch) {
          this.getPlans()
        }
      }
    },
    plans_assigned_to: {
      deep: true,
      handler() {
        if (!this.dont_fetch) {
          this.getPlans()
        }
      }
    },
    plans_start_date_range() {
      if (!this.dont_fetch) {
        this.getPlans()
      }
    },
    plans_due_date_range() {
      if (!this.dont_fetch) {
        this.getPlans()
      }
    },
    currentCompany() {
      this.tied_record_full = this.currentCompany
    }
    // "$store.state.ui.currentCompany": {
    //   deep: true,
    //   handler() {
    //     this.$emitter.emit(ALL_EMITTERS.CURRENT_COMPANY_UPDATED_IN_ACTIONS_TABLE)
    //   }
    // }
  },
  mounted() {
    const elements = document.getElementsByClassName("col-table-header-btn")
    elements.forEach((el) => {
      el.addEventListener(
        "click",
        (e) => {
          this.updateCursorPosition(e)
        },
        true
      )
    })
  },
  created() {
    this.all_tags = this.$store.state.data.actions_tags
    this.refreshTableView()
    if (this.preservedPageSize) {
      this.page_size = this.preservedPageSize
    }
    this.register_listeners()
    this.getTiedCompany()
  },

  activated() {
    this.refetchList()
    this.register_listeners()
    this.getTiedCompany()
  },

  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },

  methods: {
    updatePlansHeaders() {
      this.drag = false
      this.$store.dispatch("ui/setUIValue", {
        plans_activities_table_headers: {
          ...this.$store.state.ui_options.plans_activities_table_headers,
          [this.componentReference]: this.plan_headers.slice(1).map((header) => header.id)
        }
      })
    },
    sortRecords() {
      this.ordering_query = this.plan_headers
        .filter((h) => h.id != "actions" && h.id != "tags" && h.id != "companies" && h.id != "contacts" && h.id != "collaborators")
        .filter((el) => el.sort != 0)
        .sort((a, b) => a.sort_index - b.sort_index)
        .map((el) => `${String(el.sort).replace("1", "")}${el.id == "date" ? "due_date" : el.id}`)
        .join(",")
      this.getPlans()
    },
    handleChangeColumnFilter(column_filter) {
      this.current_column_filter = column_filter
    },
    sortActivities() {},
    handleRemoveColumnFilter(element, closeFilterModal, close) {
      let index
      if (element.id == "date") {
        index = this.plan_filters.findIndex((x) => x["due_date_start"])
        if (index != -1) {
          this.plan_filters.splice(index, 1)
        }
        index = this.plan_filters.findIndex((x) => x["due_date_end"])
        if (index != -1) {
          this.plan_filters.splice(index, 1)
        }
        index = this.plan_headers.findIndex((x) => x.id == element.id)
        if (index != -1) {
          this.plan_headers[index].value = null
        }
      } else if (element.id == "start_date") {
        index = this.plan_filters.findIndex((x) => x["start_date_start"])
        if (index != -1) {
          this.plan_filters.splice(index, 1)
        }
        index = this.plan_filters.findIndex((x) => x["start_date_end"])
        if (index != -1) {
          this.plan_filters.splice(index, 1)
        }
        index = this.plan_headers.findIndex((x) => x.id == element.id)
        if (index != -1) {
          this.plan_headers[index].value = null
        }
      } else {
        index = this.plan_filters.findIndex((x) => x[element.id])
        if (index != -1) {
          this.plan_filters.splice(index, 1)
        }
        index = this.plan_headers.findIndex((x) => x.id == element.id)
        if (index != -1) {
          this.plan_headers[index].value = null
        }
      }
      closeFilterModal()
      close()
    },
    handleSubmitColumnFilter(closeFilterModal, close) {
      let column, value, column2, value2
      if (this.current_column_filter.id == "name") {
        column = "name"
        value = this.current_column_filter.value
      } else if (this.current_column_filter.id == "companies") {
        column = this.current_column_filter.id
        value = this.current_column_filter.value.map((c) => c.id).join(",")
      } else if (this.current_column_filter.id == "contacts") {
        column = this.current_column_filter.id
        value = this.current_column_filter.value.map((c) => c.id).join(",")
      } else if (this.current_column_filter.id == "collaborators") {
        column = "collaborators"
        value = this.current_column_filter.value.join(",")
      } else if (this.current_column_filter.id == "status") {
        column = this.current_column_filter.id
        value = [this.current_column_filter.value].join(",")
      } else if (this.current_column_filter.id == "type") {
        column = "type"
        value = this.current_column_filter.value.join(",")
      } else if (this.current_column_filter.id == "tags") {
        column = "tags"
        value = this.current_column_filter.value.join(",")
      } else if (this.current_column_filter.id == "category") {
        column = "category"
        value = this.current_column_filter.value.join(",")
      } else if (this.current_column_filter.id == "date") {
        column = "due_date_start"
        value = this.$moment(this.current_column_filter.value.start).startOf("day").toISOString()
        column2 = "due_date_end"
        value2 = this.$moment(this.current_column_filter.value.end).startOf("day").toISOString()
      } else if (this.current_column_filter.id == "start_date") {
        column = "start_date_start"
        value = this.$moment(this.current_column_filter.value.start).startOf("day").toISOString()
        column2 = "start_date_end"
        value2 = this.$moment(this.current_column_filter.value.end).startOf("day").toISOString()
      }
      let index = this.plan_filters.findIndex((x) => x[column])
      if (index != -1) {
        this.plan_filters[index][column] = value
      } else {
        this.plan_filters.push({ [column]: value })
      }
      if (column2) {
        index = this.plan_filters.findIndex((x) => x[column2])
        if (index != -1) {
          this.plan_filters[index][column2] = value2
        } else {
          this.plan_filters.push({ [column2]: value2 })
        }
      }
      closeFilterModal()
      close()
    },
    refreshTableView() {
      if (this.$store.state.ui_options.plans_activities_table_headers) {
        if (this.$store.state.ui_options.plans_activities_table_headers[this.componentReference]) {
          this.plan_headers = this.$store.state.ui_options.plans_activities_table_headers[this.componentReference].map((header_id) => {
            let header = this.all_headers.find((x) => x.id == header_id) || {
              id: header_id,
              label: header_id
            }
            return { ...header }
          })
        } else {
          this.plan_headers = this.all_headers.map((header) => header)
        }
      } else {
        this.plan_headers = this.all_headers.map((header) => header)
        this.$store.dispatch("ui/setUIValue", {
          plans_activities_table_headers: {
            [this.componentReference]: this.all_headers.map((x) => x.id)
          }
        })
      }
      if (!this.editing_disabled) {
        this.plan_headers.unshift({ label: "", id: "actions" })
      }
    },
    showAllAssignedTags(object) {
      if (object?.is_all_assigned_tags_shown) {
        object["is_all_assigned_tags_shown"] = false
      } else {
        object["is_all_assigned_tags_shown"] = true
      }
    },
    updatePlansPage({ page, page_size }) {
      this.$emit("preservedFilters", { page: page, page_size: page_size })
      this.page_size = page_size
      this.getPlans(page, page_size)
    },

    handlePlansScroll(e) {
      this.plans_top_scroll = e.target.scrollTop
    },
    getRecordActions(record) {
      return [
        {
          name: this.$t("Visit") + ` ${this.$utils.getRecordName(record)}`,
          action: () => {
            this.$utils.Record(record).open()
          },
          icon: "Link"
        },
        {
          name: this.$t("View notes"),
          action: () => {
            this.openModalNotes(record)
          },
          icon: "StickyNote"
        },
        {
          name: this.$t("Create Plan"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_PLAN, {
              record: record
            })
          },
          icon: "List"
        },

        {
          name: this.$t("Assign Owner"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_OWNER, { record: record })
          },
          icon: "User"
        },
        {
          name: this.$t("Assign Co-owners"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CHANGE_CO_OWNERS, {
              record: record
            })
          },
          icon: "Users"
        },

        {
          name: this.$t("Send Email"),
          action: () => {
            const i_service = this.$store.state.integration.integrations.find((i) => i.name == "gmail")
            if (i_service && i_service.scope.includes("https://www.googleapis.com/auth/gmail.modify")) {
              if (i_service.status == "on") {
                this.$emitter.emit(ALL_EMITTERS.SEND_EMAIL, {
                  record: record,
                  object_type: record.type
                })
              } else {
                this.$emitter.emit(ALL_EMITTERS.INTEGRATION_MISSING_MODAL, {
                  message: this.$t("Email integration is not active, Activate integration to send an email")
                })
              }
            } else {
              this.$emitter.emit(ALL_EMITTERS.INTEGRATION_MISSING_MODAL, {
                message: this.$t("In order to send an email please link your account to your Email.")
              })
            }
          },
          icon: "Mail"
        }
      ]
    },
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.CURRENT_COMPANY_UPDATED_IN_ACTIONS_TABLE, () => {
        if (this.connectTo !== "another_record" && this.$store.state.ui.currentCompany) {
          this.getTiedCompany()
        }
      })
      this.$emitter.on(ALL_EMITTERS.NEW_PLAN_ADDED, (plan) => {
        google_event("create_plan_click", {
          event_label: "Create new plan",
          page: this.currentTemplate.page,
          name: this.currentTemplate.name,
          user_name: this.$store.state.auth.user.full_name,
          user_email: this.$store.state.auth.user.email,
          organization: this.$store.state.organization.name
        })
        this.addRemoveOrUpdateActionInTableRelatedToFilters(plan, "plan")
      })
      this.$emitter.on(ALL_EMITTERS.PLAN_UPDATED, (plan) => {
        this.all_tags = this.$store.state.data.actions_tags
        this.addRemoveOrUpdateActionInTableRelatedToFilters(plan, "plan", true)
      })
      this.$emitter.on(ALL_EMITTERS.PLAN_REMOVED, (plan) => {
        const index = this.plans?.results.findIndex((p) => p.id == plan.id)
        this.$utils.removeItem(this.plans?.results, plan, "id")
        if (index !== -1) {
          this.plans.count -= 1
        }
      })
      this.$emitter.on(ALL_EMITTERS.UPDATE_COUNT_NOTES_IN_RECORDS_TABLE, ({ id: id, count: count }) => {
        this.plans.results.map((plan) => {
          let index = plan?.companies?.findIndex((comp) => comp.id == id)
          if (index != -1) {
            plan.companies[index]["notes_summary"]["count"] = count
          }
        })
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.CURRENT_COMPANY_UPDATED_IN_ACTIONS_TABLE)
      this.$emitter.off(ALL_EMITTERS.NEW_PLAN_ADDED)
      this.$emitter.off(ALL_EMITTERS.PLAN_UPDATED)
      this.$emitter.off(ALL_EMITTERS.PLAN_REMOVED)
      this.$emitter.off(ALL_EMITTERS.UPDATE_COUNT_NOTES_IN_RECORDS_TABLE)
    },

    addRemoveOrUpdateActionInTableRelatedToFilters(item, item_type, updated) {
      const all_filters = {}

      all_filters["status"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_status`]
      all_filters["name"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_search_term`]
      all_filters["companies"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_companies`]
      all_filters["contacts"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_contacts`]
      all_filters["assigned_to"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_assigned_to`]
      all_filters["due_date_start"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_due_date_range`]?.start
      all_filters["due_date_end"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_due_date_range`]?.end

      if (this.initialFilter?.types && this.$store.state.data[`${item_type}_types`]) {
        all_filters["type"] = this.$store.state.data[`${item_type}_types`]
          .filter((t) => this.initialFilter.types.includes(t.value))
          .map((t) => t.value)
      }

      let should_add_to_table = true

      if (all_filters["status"]?.length) {
        let item_status = item.status
        if (item.show_dynamic_status) {
          item_status = item.summary.dynamic_status
        }
        if (!all_filters["status"].includes(item_status)) {
          should_add_to_table = false
        }
      }

      if (all_filters["name"]) {
        if (!item.name.includes(all_filters["name"])) {
          should_add_to_table = false
        }
      }

      if (all_filters["companies"]?.length) {
        let item_companies = null
        if (item_type == "plan") {
          item_companies = item.companies
        } else {
          item_companies = [item.record]
        }
        if (!all_filters["companies"].filter((c) => item_companies.map((c) => c.id).includes(c.id)).length) {
          should_add_to_table = false
        }
      }

      if (all_filters["contacts"]?.length) {
        if (!all_filters["contacts"].filter((c) => item.contacts.map((c) => c.id).includes(c.id)).length) {
          should_add_to_table = false
        }
      }

      if (all_filters["assigned_to"]?.length) {
        let item_users = null
        if (item_type == "plan") {
          item_users = item.collaborators
        } else {
          item_users = item.assigned_to
        }
        if (!all_filters["assigned_to"].filter((c) => item_users.map((c) => (c.id ? c.id : c)).includes(c)).length) {
          should_add_to_table = false
        }
      }

      if (this.initialFilter?.relative_due_date) {
        const relative_due_date_text = this.initialFilter?.relative_due_date

        if (relative_due_date_text !== null && relative_due_date_text !== "") {
          const today = new Date()
          if (relative_due_date_text === "today") {
            const startOfDay = new Date(today)
            startOfDay.setHours(0, 0, 0, 0)
            const endOfDay = new Date(today)
            endOfDay.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfDay
            all_filters["due_date_end"] = endOfDay
          } else if (relative_due_date_text === "tomorrow") {
            const tomorrow = new Date(today)
            tomorrow.setDate(today.getDate() + 1)
            const startOfTomorrow = new Date(tomorrow)
            startOfTomorrow.setHours(0, 0, 0, 0)
            const endOfTomorrow = new Date(tomorrow)
            endOfTomorrow.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfTomorrow
            all_filters["due_date_end"] = endOfTomorrow
          } else if (relative_due_date_text === "yesterday") {
            const yesterday = new Date(today)
            yesterday.setDate(today.getDate() - 1)
            const startOfYesterday = new Date(yesterday)
            startOfYesterday.setHours(0, 0, 0, 0)
            const endOfYesterday = new Date(yesterday)
            endOfYesterday.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfYesterday
            all_filters["due_date_end"] = endOfYesterday
          } else if (relative_due_date_text === "this_week") {
            const startOfWeek = new Date(today)
            startOfWeek.setDate(today.getDate() - today.getDay())
            const endOfWeek = new Date(today)
            endOfWeek.setDate(startOfWeek.getDate() + 6)
            endOfWeek.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfWeek
            all_filters["due_date_end"] = endOfWeek
          } else if (relative_due_date_text === "next_week") {
            const startOfNextWeek = new Date(today)
            startOfNextWeek.setDate(today.getDate() - today.getDay() + 7)
            const endOfNextWeek = new Date(startOfNextWeek)
            endOfNextWeek.setDate(startOfNextWeek.getDate() + 6)
            endOfNextWeek.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfNextWeek
            all_filters["due_date_end"] = endOfNextWeek
          } else if (relative_due_date_text === "last_week") {
            const startOfLastWeek = new Date(today)
            startOfLastWeek.setDate(today.getDate() - today.getDay() - 7)
            const endOfLastWeek = new Date(startOfLastWeek)
            endOfLastWeek.setDate(startOfLastWeek.getDate() + 6)
            endOfLastWeek.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfLastWeek
            all_filters["due_date_end"] = endOfLastWeek
          } else if (relative_due_date_text === "this_month") {
            const startOfMonth = new Date(today)
            startOfMonth.setDate(1)
            const endOfMonth = new Date(today)
            endOfMonth.setMonth(endOfMonth.getMonth() + 1)
            endOfMonth.setDate(0)
            endOfMonth.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfMonth
            all_filters["due_date_end"] = endOfMonth
          } else if (relative_due_date_text === "next_month") {
            const startOfNextMonth = new Date(today)
            startOfNextMonth.setMonth(startOfNextMonth.getMonth() + 1)
            startOfNextMonth.setDate(1)
            const endOfNextMonth = new Date(startOfNextMonth)
            endOfNextMonth.setMonth(endOfNextMonth.getMonth() + 1)
            endOfNextMonth.setDate(0)
            endOfNextMonth.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfNextMonth
            all_filters["due_date_end"] = endOfNextMonth
          } else if (relative_due_date_text === "last_month") {
            const startOfLastMonth = new Date(today)
            startOfLastMonth.setMonth(startOfLastMonth.getMonth() - 1)
            startOfLastMonth.setDate(1)
            const endOfLastMonth = new Date(startOfLastMonth)
            endOfLastMonth.setMonth(endOfLastMonth.getMonth() + 1)
            endOfLastMonth.setDate(0)
            endOfLastMonth.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfLastMonth
            all_filters["due_date_end"] = endOfLastMonth
          } else if (relative_due_date_text === "this_quarter") {
            const quarter = Math.floor((today.getMonth() - 1) / 3) + 1
            let startOfQuarter, endOfQuarter
            if (quarter === 1) {
              startOfQuarter = new Date(today.getFullYear(), 0, 1)
              endOfQuarter = new Date(today.getFullYear(), 2, 31, 23, 59, 59, 999)
            } else if (quarter === 2) {
              startOfQuarter = new Date(today.getFullYear(), 3, 1)
              endOfQuarter = new Date(today.getFullYear(), 5, 30, 23, 59, 59, 999)
            } else if (quarter === 3) {
              startOfQuarter = new Date(today.getFullYear(), 6, 1)
              endOfQuarter = new Date(today.getFullYear(), 8, 30, 23, 59, 59, 999)
            } else {
              startOfQuarter = new Date(today.getFullYear(), 9, 1)
              endOfQuarter = new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999)
            }
            all_filters["due_date_start"] = startOfQuarter
            all_filters["due_date_end"] = endOfQuarter
          } else if (relative_due_date_text === "next_quarter") {
            let startOfNextQuarter, endOfNextQuarter
            if (today.getMonth() >= 9) {
              // October, November, December
              startOfNextQuarter = new Date(today.getFullYear() + 1, 0, 1)
              endOfNextQuarter = new Date(today.getFullYear() + 1, 2, 31, 23, 59, 59, 999)
            } else {
              const quarter = Math.floor((today.getMonth() - 1) / 3) + 2
              if (quarter === 2) {
                startOfNextQuarter = new Date(today.getFullYear(), 3, 1)
                endOfNextQuarter = new Date(today.getFullYear(), 5, 30, 23, 59, 59, 999)
              } else if (quarter === 3) {
                startOfNextQuarter = new Date(today.getFullYear(), 6, 1)
                endOfNextQuarter = new Date(today.getFullYear(), 8, 30, 23, 59, 59, 999)
              } else {
                startOfNextQuarter = new Date(today.getFullYear(), 9, 1)
                endOfNextQuarter = new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999)
              }
            }
            all_filters["due_date_start"] = startOfNextQuarter
            all_filters["due_date_end"] = endOfNextQuarter
          } else if (relative_due_date_text === "last_quarter") {
            let startOfLastQuarter, endOfLastQuarter
            if (today.getMonth() <= 2) {
              // January, February, March
              startOfLastQuarter = new Date(today.getFullYear() - 1, 9, 1)
              endOfLastQuarter = new Date(today.getFullYear() - 1, 11, 31, 23, 59, 59, 999)
            } else {
              const quarter = Math.floor((today.getMonth() - 1) / 3)
              if (quarter === 1) {
                startOfLastQuarter = new Date(today.getFullYear(), 0, 1)
                endOfLastQuarter = new Date(today.getFullYear(), 2, 31, 23, 59, 59, 999)
              } else if (quarter === 2) {
                startOfLastQuarter = new Date(today.getFullYear(), 3, 1)
                endOfLastQuarter = new Date(today.getFullYear(), 5, 30, 23, 59, 59, 999)
              } else {
                startOfLastQuarter = new Date(today.getFullYear(), 6, 1)
                endOfLastQuarter = new Date(today.getFullYear(), 8, 30, 23, 59, 59, 999)
              }
            }
            all_filters["due_date_start"] = startOfLastQuarter
            all_filters["due_date_end"] = endOfLastQuarter
          } else if (relative_due_date_text === "this_year") {
            const startOfYear = new Date(today.getFullYear(), 0, 1)
            const endOfYear = new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999)
            all_filters["due_date_start"] = startOfYear
            all_filters["due_date_end"] = endOfYear
          } else if (relative_due_date_text === "next_year") {
            const startOfNextYear = new Date(today.getFullYear() + 1, 0, 1)
            const endOfNextYear = new Date(today.getFullYear() + 1, 11, 31, 23, 59, 59, 999)

            all_filters["due_date_start"] = startOfNextYear
            all_filters["due_date_end"] = endOfNextYear
          } else if (relative_due_date_text === "last_year") {
            const startOfLastYear = new Date(today.getFullYear() - 1, 0, 1)
            const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31, 23, 59, 59, 999)
            all_filters["due_date_start"] = startOfLastYear
            all_filters["due_date_end"] = endOfLastYear
          }
        }
      }

      if (all_filters["due_date_start"]) {
        if (
          !(
            new Date(item.due_date) >= new Date(all_filters["due_date_start"]) &&
            new Date(item.due_date) <= new Date(all_filters["due_date_end"])
          )
        ) {
          should_add_to_table = true
        }
      }

      if (should_add_to_table) {
        if (!this[`${item_type}s`].results.find((i) => i.id == item.id)) {
          this[`${item_type}s`].count += 1
        }
        this.$utils.replaceOrAddItem(this[`${item_type}s`].results, item, "id", true)
      } else if (updated) {
        const index = this[`${item_type}s`].results.findIndex((p) => p.id == item.id)
        this.$utils.removeItem(this[`${item_type}s`].results, item, "id")
        if (index !== -1) {
          this[`${item_type}s`].count -= 1
        }
      }
    },
    getTiedCompany() {
      if (
        (this.connectTo == "this_record" || this.initialFilter?.companies?.includes("this_record")) &&
        this.$store.state.ui.currentCompany
      ) {
        this.tied_record_full = this.$store.state.ui.currentCompany
        this.getPlans()
      } else if (this.connectTo == "another_record") {
        this.$store.dispatch("data/getRecord", this.linkedRecord.id ? this.linkedRecord.id : this.linkedRecord).then(() => {
          this.tied_record_full = this.$store.state.data.records_fetched[this.linkedRecord.id ? this.linkedRecord.id : this.linkedRecord]
          this.getPlans()
        })
      } else {
        this.getPlans()
      }
    },
    refetchList() {
      this.getPlans()
    },
    handleClickFilter() {
      this.plans_search_term = null
      this.plan_filters = []
      this.plan_headers.map((header) => (header["value"] = null))
    },
    openModalNotes(record) {
      this.$emitter.emit(ALL_EMITTERS.ADD_NOTES_RECORD, { company: record })
    },
    handlePlanSetContactsList(e, plan) {
      const post = {
        id: plan.id,
        dont_load: true,
        contacts: e.map((c) => c.id)
      }
      this.$store.dispatch("data/updatePlan", { plan: post }).then(() => {})
    },
    handlePlanSetTeamMembersList(e, plan) {
      const post = {
        id: plan.id,
        dont_load: true,
        collaborators: e.map((c) => c.id)
      }
      this.$store.dispatch("data/updatePlan", { plan: post }).then(() => {})
    },
    createNewPlan() {
      if (!this.tied_record) {
        return this.$emitter.emit(ALL_EMITTERS.CREATE_PLAN)
      } else {
        const data = {
          record: this.tied_record_full,
          contact: ""
        }
        if (this.tied_record_full?.type !== "company" && this.tied_record_full?.type !== "opportunity") {
          if (this.tied_record_full.parent) {
            data["record"] = this.tied_record_full.parent
          }
          if (this.tied_record_full?.type == "contact") {
            data["contact"] = this.tied_record_full
          }
        }
        return this.$emitter.emit(ALL_EMITTERS.CREATE_PLAN, data)
      }
    },

    loadMoreActions(page) {
      const action_name = "plans"
      let url_calc
      if (this[action_name].next) {
        url_calc = this[action_name].next.replace(/page=\d+/, `page=${page}`)
      } else {
        url_calc = this[action_name].previous.replace(/page=\d+/, `page=${page}`)
      }
      dataService.getRecordsByUrl(url_calc).then((res) => {
        this[action_name] = { ...res.data, results: res.data.results }
      })
    },

    getPlans(page = 1, page_size = this.page_size) {
      const promises = []

      if (!this.$utils.isEmpty(this.initialFilter)) {
        this.dont_fetch = true
        if (this.initialFilter.status) {
          this.plans_status = this.initialFilter.status
        }
        this.initialFilter?.companies?.forEach((company) => {
          if (company !== "this_record") {
            promises.push(this.$store.dispatch("data/getRecord", typeof company == "string" ? company : company.id))
          }
        })
        this.initialFilter?.contacts?.forEach((contact) => {
          promises.push(this.$store.dispatch("data/getRecord", typeof contact == "string" ? contact : contact.id))
        })

        if (this.initialFilter.collaborators?.length) {
          this.plans_assigned_to = this.initialFilter.collaborators
        }
      }

      Promise.all(promises).then((values) => {
        const plans_contacts_calc = []
        const plans_companies_calc = []
        values.forEach((res_value) => {
          if (res_value.data.type == "contact") {
            plans_contacts_calc.push(res_value.data)
          } else {
            plans_companies_calc.push(res_value.data)
          }
        })

        if (plans_companies_calc.length) {
          this.plans_companies = plans_companies_calc
        } else {
          this.plans_companies = null
        }
        if (plans_contacts_calc.length) {
          this.plans_contacts = plans_contacts_calc
        } else {
          this.plans_contacts = null
        }
        let obj = {}
        this.plan_filters.map((x) => {
          obj[Object.keys(x)] = Object.values(x)[0]
        })
        let params = {
          ...obj,
          ordering: this.ordering_query,
          page_size: page_size,
          goals_page_size: 6,
          tasks_page_size: 6,
          notes_page_size: 3,
          ...(!!this.plans_status && { status: this.plans_status.join(",") }),
          ...(!!this.plans_search_term && { name: this.plans_search_term }),
          ...(!!this.plans_companies && {
            companies: this.plans_companies.map((c) => c.id).join(",")
          }),
          ...(!!this.plans_contacts && {
            contacts: this.plans_contacts.map((c) => c.id).join(",")
          }),
          ...(!!this.plans_assigned_to && {
            collaborators: this.plans_assigned_to.join(",")
          })
        }
        if (this.initialFilter?.types) {
          params["type"] = this.$store.state.data.plan_types
            .filter((t) => this.initialFilter.types.includes(t.value))
            .map((t) => t.value)
            .join(",")
        }

        if (this.initialFilter?.relative_start_date) {
          params["relative_start_date"] = this.initialFilter.relative_start_date
        }
        if (this.initialFilter?.relative_due_date) {
          params["relative_due_date"] = this.initialFilter.relative_due_date
        }
        if (this.plans_start_date_range) {
          params["start_date_start"] = this.$moment.utc(this.plans_start_date_range.start).startOf("day").toISOString()
          params["start_date_end"] = this.$moment.utc(this.plans_start_date_range.end).endOf("day").toISOString()
        }
        if (this.plans_due_date_range) {
          params["due_date_start"] = this.$moment(this.plans_due_date_range.start).startOf("day").toISOString()
          params["due_date_end"] = this.$moment(this.plans_due_date_range.end).endOf("day").toISOString()
        }
        params["expand"] = "record"
        params["prevent_loading"] = true
        if (!this.tied_record) {
          if (page == 1) {
            this.$store.dispatch("data/getPlans", params).then((res) => {
              this.plans = res.data
              this.dont_fetch = false
            })
          } else {
            this.loadMoreActions(page)
          }
        } else {
          let id = this.tied_record

          const filter_fields = {}
          if (this.tied_record_full?.type == "company" || this.tied_record_full?.type == "opportunity" || !this.tied_record_full?.type) {
            filter_fields["companies"] = id
          }
          if (this.tied_record_full?.type == "contact") {
            filter_fields["contacts"] = id
          }
          if (page == 1) {
            this.$store
              .dispatch("data/getRecordPlans", {
                id: id,
                params: { ...params, ...filter_fields }
              })
              .then((res) => {
                this.plans = res.data
                this.dont_fetch = false
              })
          } else {
            this.loadMoreActions(page)
          }
        }
      })
    }
  }
}
</script>
